import * as React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { Helmet } from 'react-helmet'
import '../services/i18n'
import './index.sass'
import { useState, useEffect } from 'react'
import { GetStarted } from '../components/common/get-started'
import { CountryPopup } from '../components/common/country-popup'
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { windowGlobal } from '../utils/window-global'
import { languageCodes } from "../config/languages";
import i18n from "../services/i18n";

export const AppContext = React.createContext(null)

export const Layout = ({ pageTitle, children, country = 'uae', language = 'en', askForMarket = true, marketAddresses, structuredData = null }) => {
  const [getStartedPopupVisible, setGetStartedPopupVisible] = useState(false)
  const [countryPopupVisible, setCountryPopupVisible] = useState(false)

  useEffect(() => {
    i18n.changeLanguage(language)
  }, [language])

  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
      allMdx(filter: {frontmatter: {type: {eq: "page"}}}) {
        nodes {
          frontmatter {
            country
            slug
          }
        }
      }
    }
  `)

  React.useEffect(() => {
    const isFirstVisit = localStorage.getItem('didSelectMarket') === null
    if (isFirstVisit && askForMarket && !windowGlobal.location.href.includes('sp-signup')) {
      setCountryPopupVisible(true)
    }
    if (windowGlobal.location.href.includes('/hire')) {
      windowGlobal.fbq?.('trackCustom', 'HirePageView')
    }
  }, [])

  const availablePages = React.useMemo(() => {
    return data.allMdx.nodes.reduce((acc, { frontmatter }) => {
      const { country, slug } = frontmatter

      return {
        ...acc,
        [country]: acc[country] ? [...acc[country], slug] : [slug]
      }
    }, {})
  }, [])

  return (
    <>
      <AppContext.Provider value={{ availablePages, getStartedPopupVisible, setGetStartedPopupVisible, country, marketAddresses, language }}>
        <Helmet title={`${data.site.siteMetadata.title} - ${pageTitle}`}>
          <html dir={language === languageCodes.AR ? 'rtl' : 'ltr'} />
          {structuredData !== null && (
            <script type="application/ld+json">
              {`
                ${JSON.stringify(structuredData)}
              `}
            </script>
          )}
        </Helmet>
        <ToastContainer />
        {children}
        <GetStarted
          visible={getStartedPopupVisible}
          onClose={() => { setGetStartedPopupVisible(false) }}
          country={country}
        />
        {askForMarket && (
          <CountryPopup
            visible={countryPopupVisible}
            onClose={() => { setCountryPopupVisible(false) }}
            country={country}
            availablePages={availablePages}
          />
        )}
      </AppContext.Provider>
    </>
  )
}
